function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M51.4583 8.125H13.5417C10.5625 8.125 8.125 10.5625 8.125 13.5417V51.4583C8.125 54.4375 10.5625 56.875 13.5417 56.875H51.4583C54.4375 56.875 56.875 54.4375 56.875 51.4583V13.5417C56.875 10.5625 54.4375 8.125 51.4583 8.125ZM51.4583 51.4583H13.5417V13.5417H51.4583V51.4583ZM44.9042 20.5291L48.7229 24.375L27.0562 46.0416L16.2229 35.2354L20.0687 31.4166L27.0562 38.3771L44.9042 20.5291Z",
  fill: "url(#paint0_linear)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 32.5,
  y1: 8.125,
  x2: 32.5,
  y2: 56.875,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#0099BB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#007A6A"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/PollIcon.f7f2c640.svg";
export { SvgComponent as ReactComponent };